module.exports = __webpack_public_path__ + "static/media/banner-photo360@2x.fdb437e6.jpg";